import { COLOR } from '../../settings';
import type { IAvatarOptionsProps } from '../../types';
import ColorPanel from '@/components/AvatarOptionsPanel/ColorPanel';

export const ColorAvatar: React.FC<IAvatarOptionsProps<string>> = ({
  name,
  option,
  setOption
}) => {
  const handleSetOption = (value: string) => setOption(name, value);
  const defaultColor = option || COLOR[1];

  return (
    <ColorPanel
      setColor={handleSetOption}
      color={defaultColor}
      palettes={COLOR}
    />
  );
};
